import React, { useState, useEffect } from "react";
import "mdb-ui-kit/css/mdb.min.css";
import { InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

import "./DashboardForm.css";
import "../Styles/AddVaritesForm.css";
// import Input from "@mui/material/Input";
import OutlinedInput from "@mui/material/OutlinedInput";
import axios from "axios";
import ApiSettings from "../.././../../Settings/ApiSettings.json";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AddActivityTypeForm(props) {
  const [loading, setLoading] = useState(false);
  const [IpAddress, setIpAddree] = useState("");
  const [dataOFVarieties, setdataOFVarieties] = useState([]);
  const [dataOfGroupsCarriers, setdataOfGroupsCarriers] = useState([]);
  const [careerName, setCareerName] = useState("");
  const [selectedGroupCarrier, setselectedGroupCarrier] = useState({});

  const [selectedVarietiesCarrierName, setselectedVarietiesCarrierName] =
    useState([]);

  const [selectedCalculationType, setselectedCalculationType] = useState(0);
  const [amountForEachVarietiesCarriers, setamountForEachVarietiesCarriers] =
    useState([]);
  const [relatedGroupCarriersDate, setrelatedGroupCarriersDate] = useState([]);
  const [showBoxOfAddCarriers, setshowBoxOfAddCarriers] = useState(false);

  const [filteredDataForCarrier, setfilteredDataForCarrier] = useState([]);
  const [ErrorMessage, setErrorMessage] = useState({
    activityTypeError: "",
    CalculationTypeError: "",
    VaritiesCarrierError: "",
  });

  useEffect(() => {}, []);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  //get data of varieties Carrier ....
  const getDataOfVarietiesCarrier = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/VarietiesCarrier/show",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setdataOFVarieties(data.data.data);
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };

  //get data of group Carrier ....
  const getDataOfGroupsCarriers = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/GroupsCarrier/show",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setdataOfGroupsCarriers(data.data.data);
        }
      }
    } catch (err) {
      // alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };

  // get related carriers for each group you selected.
  const getrelatedGroupCarriersDate = async (item) => {
    let data = null;
    try {
      data = await axios({
        method: "post",
        url: IpAddress + "/GroupsCarrier/getRelatedCarriers",
        data: {
          GroupsCarriersID: item.id,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setfilteredDataForCarrier([]);
          setrelatedGroupCarriersDate(data.data.data);
          let dataTemp = data.data.data;
          let arrTemp = [];
          dataTemp.forEach((element) => {
            setfilteredDataForCarrier((item) => [
              ...item,
              {
                id: element.id,
                name: element.name,
                Categories: "أ",
              },
            ]);
          });
        } else {
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
    }
  };

  //sent data of new carriers with the related informatio with Varieties carrier..
  const sentDataOFNewCarrier = async () => {
    if (!selectedGroupCarrier?.id) {
      setsnackBar({
        ...snackBar,
        message: "يرجا أختيار المجموعة الخاصة بالمهنة",
        severity: "warning",
        open: true,
      });
      return;
    }

    if (!careerName) {
      setsnackBar({
        ...snackBar,
        message: "يجب أدخال  أسم النشاط ",
        severity: "warning",
        open: true,
      });
      return;
    }

    let checknow = 0;
    if (amountForEachVarietiesCarriers.length > 0) {
      amountForEachVarietiesCarriers.map((data) => {
        if (!data.amount) {
          checknow = 1;
        }
      });
    } else if (selectedCalculationType == 0) {
      setsnackBar({
        ...snackBar,
        message: "يجب اختيار صنف لهذا النشاط",
        severity: "warning",
        open: true,
      });
      return;
    }

    if (checknow == 1) {
      setsnackBar({
        ...snackBar,
        message: "يجب تعبئت جميع حقول الاصناف المتاحة  لهذا النشاط",
        severity: "warning",
        open: true,
      });
      return;
    }

    setLoading(true);
    let data = null;
    let formData = {
      carrierName: careerName,
      GroupOfCarrierID: selectedGroupCarrier?.id.toString(),
      VarietiesCarrierWithAmount: amountForEachVarietiesCarriers,
      CalculationType: selectedCalculationType.toString(),
    };

    try {
      data = await axios({
        method: "post",
        url: IpAddress + "/Carriers/insert",
        data: formData,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          getrelatedGroupCarriersDate(selectedGroupCarrier);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
        } else if (data.data.status == 408) {
          if (data.data.data) {
            let message = "يرجا التحقق من ما يلي :-";
            if (data.data.data.carrierName)
              ErrorMessage.activityTypeError = data.data.data.carrierName;
            if (data.data.data.CalculationType)
              ErrorMessage.CalculationTypeError =
                data.data.data.CalculationType;
            if (data.data.data.VarietiesCarrierWithAmount)
              ErrorMessage.VaritiesCarrierError =
                data.data.data.VarietiesCarrierWithAmount;

            if (data.data.data.GroupOfCarrierID) {
              message += "\n " + data.data.data.GroupOfCarrierID;

              setsnackBar({
                ...snackBar,
                message: message,
                severity: "warning",
                open: true,
              });
            }
          }
        } else {
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  const { vertical, horizontal, open } = snackBar;
  useEffect(() => {
    setIpAddree(ApiSettings.apiUrl);
    getDataOfVarietiesCarrier(ApiSettings.apiUrl);
    getDataOfGroupsCarriers(ApiSettings.apiUrl);
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  //push selected varietiesCarrierName
  const pushSelectedVarietiesCarrierName = (name) => {
    if (selectedVarietiesCarrierName.length > 0) {
      let checkifExists = selectedVarietiesCarrierName.includes(name);
      if (!checkifExists) {
        setselectedVarietiesCarrierName((item) => [...item, name]);
        setamountForEachVarietiesCarriers((item) => [
          ...item,
          {
            amount: "",
            flag: name,
          },
        ]);
        return;
      }
      setselectedVarietiesCarrierName(
        selectedVarietiesCarrierName.filter((item) => item !== name)
      );
      setamountForEachVarietiesCarriers(
        amountForEachVarietiesCarriers.filter((item) => item.flag !== name)
      );
      return;
    } else {
      setselectedVarietiesCarrierName((item) => [...item, name]);
      setamountForEachVarietiesCarriers((item) => [
        ...item,
        {
          amount: "",
          flag: name,
        },
      ]);
    }
  };

  const pushAmountForVarietiesCarrier = (amount, flag) => {
    let getArray = [...amountForEachVarietiesCarriers];
    for (let i = 0; i < getArray.length; i++) {
      if (getArray[i].flag == flag) {
        getArray[i].amount = amount;
      }
    }
    setamountForEachVarietiesCarriers(getArray);
    // console.log(getArray);
  };

  console.log("amountForEachVarietiesCarriers", amountForEachVarietiesCarriers);
  return (
    <div
      className={`FormContainer  ${
        props.inactive === false ? "activeSideMenu" : ""
      }`}
      style={{
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexFlow: "row wrap",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            backgroundColor: "#5f7b8a",
            color: "#FFFFFF",
            paddingTop: 10,
            paddingBottom: 10,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h2>اضافة نشاط</h2>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <TextField
              label="أسم النشاط"
              variant="outlined"
              onChange={(e) => {
                setCareerName(e.target.value);
              }}
            />
          </FormControl>
          <Typography className="fontForError">
            {ErrorMessage.activityTypeError}
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="career-simple-select-label">
              أختر نوع المهنة
            </InputLabel>
            <Select
              labelId="career-simple-select-label"
              id="career-simple-select"
              value={selectedGroupCarrier}
              label="أختر نوع المهنة "
              onChange={(e) => {
                const data = e.target.value;

                setselectedGroupCarrier(data);
                getrelatedGroupCarriersDate(data);
              }}
            >
              {dataOfGroupsCarriers.map((data) => {
                return (
                  <MenuItem key={data.id} value={data}>
                    {data.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Typography className="fontForError">
            {ErrorMessage.CalculationTypeError}
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            marginTop: 10,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="calculation-type-simple-select-label">
              أختر من نوع الحساب
            </InputLabel>
            <Select
              labelId="calculation-type-simple-select-label"
              id="calculation-type-simple-select"
              value={selectedCalculationType}
              label="أختر من نوع الحساب "
              onChange={(e) => {
                setselectedCalculationType(e.target.value);
              }}
            >
              <MenuItem value={0}>Absolute</MenuItem>
              <MenuItem value={1}>Formula</MenuItem>
            </Select>
          </FormControl>
          <Typography className="fontForError">
            {ErrorMessage.CalculationTypeError}
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="class-multiple-chip-label">الصنف</InputLabel>
            <Select
              labelId="class-multiple-chip-label"
              id="class-multiple-chip"
              multiple
              label="أختر الاصناف"
              value={selectedVarietiesCarrierName}
              input={
                <OutlinedInput id="class-select-multiple-chip" label="Chip" />
              }
              renderValue={(selected) => (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                  }}
                >
                  {selected.map((value) => (
                    <Chip
                      key={value}
                      style={{ height: "auto" }}
                      label={value}
                    />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {dataOFVarieties.map((data) => (
                <MenuItem
                  key={data.name}
                  value={data.name}
                  onClick={(e) => {
                    pushSelectedVarietiesCarrierName(data.name);
                  }}
                >
                  {data.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography className="fontForError">
            {ErrorMessage.VaritiesCarrierError}
          </Typography>
        </div>
        {amountForEachVarietiesCarriers.length > 0 && (
          <div
            style={{
              width: "100%",
              border: "1px solid",
              borderColor: "#5f7b8a",
              margin: "10px",
              padding: "10px",
              borderWidth: "2px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: 10,
            }}
          >
            <h4>القيم لكل صنف</h4>

            {amountForEachVarietiesCarriers.map((data, index) => {
              return (
                <div
                  key={"activity_amount" + index}
                  style={{
                    display: "flex",
                    width: "70%",
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label=" الكمية..."
                      variant="outlined"
                      onChange={(e) => {
                        pushAmountForVarietiesCarrier(
                          e.target.value,
                          data.flag
                        );
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <span> صنف {data.flag}</span>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          marginTop: 10,
          backgroundColor: "#fefefe",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 30,

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: "#5f7b8a",
            width: "40%",
            fontSize: "20px",
          }}
          onClick={() => sentDataOFNewCarrier()}
        >
          {!loading ? (
            "أضافة"
          ) : (
            <div class="spinner-border " role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          )}
        </Button>
      </div>

      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
